import { CommonModule } from '@angular/common';
import { Component, computed, input, signal } from '@angular/core';
import { EventDto } from '@millionshow/api-client';
import {
  formatDateRangeShort,
  formatTime,
  toDate,
} from '../../../utils/date-formatter';
import { Icon } from '@millionshow/client-libs';
import { RouterLink } from '@angular/router';
import { NotFoundComponent } from '../../../components/not-found/not-found.component';
import { debounceTime, distinctUntilChanged, Subject } from 'rxjs';

@Component({
  selector: 'app-calendar-list-component',
  imports: [CommonModule, Icon, RouterLink, NotFoundComponent],
  templateUrl: './calendar-list.component.html',
  styleUrls: ['./calendar-list.component.css'],
})
export default class CalendarListComponent {
  items = input<EventDto[]>();

  // 현재 연도
  currentYear = signal<number>(new Date().getFullYear());

  // 검색 쿼리
  searchQuery = signal<string>('');

  // 검색 debounce
  private searchSubject = new Subject<string>();

  constructor() {
    this.searchSubject
      .pipe(debounceTime(300), distinctUntilChanged())
      .subscribe(query => {
        this.searchQuery.set(query);
      });
  }

  formatDateRangeShort = formatDateRangeShort;
  formatTime = formatTime;
  toDate = toDate;

  // 필터링된 이벤트 목록
  filteredEvents = computed(() => {
    const events = this.items() || [];
    const year = this.currentYear();
    const query = this.searchQuery().toLowerCase();

    return events.filter(event => {
      // 연도 필터
      const eventYear = new Date(event.startAt).getFullYear();
      if (eventYear !== year) return false;

      // 검색 필터
      if (query) {
        const titleMatch = event.title.toLowerCase().includes(query);
        const placeMatch = event.place?.name.toLowerCase().includes(query);
        return titleMatch || placeMatch;
      }

      return true;
    });
  });

  getStatusBadge(status: string) {
    const badges = {
      PENDING: {
        text: '예정',
        class: 'bg-blue-100 text-blue-600',
      },
      ONGOING: {
        text: '진행중',
        class: 'bg-green-100 text-green-600',
      },
      FINISHED: {
        text: '종료',
        class: 'bg-gray-100 text-gray-600',
      },
      CANCELLED: {
        text: '취소',
        class: 'bg-red-100 text-red-600',
      },
    };

    return (
      badges[status as keyof typeof badges] || {
        text: '알 수 없음',
        class: 'bg-gray-100 text-gray-600',
      }
    );
  }

  prevYear() {
    this.currentYear.set(this.currentYear() - 1);
  }

  nextYear() {
    this.currentYear.set(this.currentYear() + 1);
  }

  onSearchInput(event: Event) {
    const input = event.target as HTMLInputElement;
    this.searchSubject.next(input.value);
  }
}
